// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Page layout ────────────────────────────────────────────────────────── */
.us-page {
  max-width: 1000px; /* a trading account's title, badges and actions fit on one line */
  margin: 40px auto;
  padding: 0 20px 60px;
  font-size: 13px;
  color: var(--color-text);
}

.us-card {
  display: flex;
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;
  min-height: 380px;
}

/* ─── Sidebar ────────────────────────────────────────────────────────────── */
.us-sidebar {
  width: 180px;
  flex-shrink: 0;
  border-right: 1px solid var(--color-border);
  background: var(--color-bg-sub);
  display: flex;
  flex-direction: column;
}

.us-sidebar-header {
  padding: 20px 16px 16px;
  border-bottom: 1px solid var(--color-border);
}

.us-sidebar-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.us-sidebar-title {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-dim);
  margin: 0;
}

.us-nav {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}

.us-nav-btn {
  width: 100%;
  text-align: left;
  padding: 10px 16px;
  background: none;
  border: none;
  border-left: 2px solid transparent;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-dim);
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s, background 0.12s;
}

.us-nav-btn:hover {
  color: var(--color-text);
  background: var(--color-bg-row);
}

.us-nav-btn--active {
  color: var(--color-accent);
  border-left-color: var(--color-accent);
  background: var(--color-bg-row);
}

/* ─── Body ───────────────────────────────────────────────────────────────── */
.us-body {
  flex: 1 1;
  overflow-y: auto;
}

.us-section {
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ─── Fields ─────────────────────────────────────────────────────────────── */
.us-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--color-border);
}

.us-field:last-of-type {
  border-bottom: none;
}

.us-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-dim);
}

.us-value {
  font-size: 12px;
  color: var(--color-text);
}

.us-mono {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-muted);
  word-break: break-all;
  max-width: 260px;
  text-align: right;
}

.us-btn {
  align-self: flex-start;
  width: 100%;
}

/* ─── Billing tabs ───────────────────────────────────────────────────────── */
.us-tabs {
  display: flex;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-bg-sub);
}

.us-tab {
  padding: 10px 20px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--color-dim);
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
}

.us-tab:hover { color: var(--color-text); }

.us-tab--active {
  color: var(--color-accent);
  border-bottom-color: var(--color-accent);
}

/* ─── Invoices table ─────────────────────────────────────────────────────── */
.us-section--flush {
  padding: 0;
}

.us-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.us-table th {
  padding: 8px 16px;
  text-align: left;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--color-dim);
  background: var(--color-bg-row);
  border-bottom: 1px solid var(--color-border);
}

.us-table td {
  padding: 10px 16px;
  color: var(--color-text);
  border-bottom: 1px solid var(--color-border);
}

.us-table tr:last-child td { border-bottom: none; }
.us-table tr:hover td      { background: var(--color-bg-row); }

.us-badge {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.us-badge--paid      { color: var(--color-accent); border: 1px solid var(--color-accent); }
.us-badge--open      { color: var(--color-blue);   border: 1px solid var(--color-blue); }

/* Text-style action inside table rows (e.g. "Download PDF") */
.us-link-btn {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 12px;
  color: var(--color-accent);
  cursor: pointer;
  white-space: nowrap;
}
.us-link-btn:hover    { text-decoration: underline; }
.us-link-btn:disabled { color: var(--color-dim); cursor: default; text-decoration: none; }

/* ─── Billing history (summary + timeline) ───────────────────────────────── */
.us-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  margin: 0;
  background: var(--color-border);       /* shows through the gaps as dividers */
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;
}

.us-stat {
  padding: 12px 16px;
  background: var(--color-bg-row);
}

.us-stat dt {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-dim);
}

.us-stat dd {
  margin: 4px 0 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}

.us-timeline__year {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: var(--color-dim);
  margin: 4px 0 0;
}

.us-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.us-event {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 12px 0;
}

/* Vertical line through the dots, from the first dot to the last */
.us-event::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--color-border);
}
.us-event:first-child::before { top: 18px; }
.us-event:last-child::before  { bottom: calc(100% - 18px); }

.us-event__dot {
  position: relative;
  flex-shrink: 0;
  width: 9px;
  height: 9px;
  margin-top: 5px;
  border-radius: 50%;
  background: var(--color-dim);
  box-shadow: 0 0 0 3px var(--color-bg); /* gap between dot and line */
}

.us-event--start  .us-event__dot { background: var(--color-accent); }
.us-event--renew  .us-event__dot { background: var(--color-blue); }
.us-event--cancel .us-event__dot { background: var(--color-danger); }

.us-event__body {
  flex: 1 1;
  min-width: 0;
}

.us-event__title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}

.us-event__meta {
  margin: 3px 0 0;
  font-size: 12px;
  color: var(--color-dim);
}

.us-event__aside {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.us-event__amount {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}

.us-event__invoice {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Loading placeholders */
.us-skeleton {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--color-bg-row) 25%, var(--color-border) 50%, var(--color-bg-row) 75%);
  background-size: 200% 100%;
  animation: us-shimmer 1.4s ease-in-out infinite;
}
.us-event__dot.us-skeleton { border-radius: 50%; }
.us-skeleton--title { width: 40%; height: 12px; margin: 2px 0 8px; }
.us-skeleton--meta  { width: 65%; height: 10px; }

@keyframes us-shimmer {
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .us-skeleton { animation: none; }
}

/* Empty and error states */
.us-empty {
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 48px 28px;
}

.us-empty__icon {
  width: 32px;
  height: 32px;
  color: var(--color-dim);
  margin-bottom: 4px;
}

.us-empty__title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}

.us-empty__action {
  width: auto;
  margin-top: 8px;
}

@media (max-width: 560px) {
  .us-stats { grid-template-columns: 1fr; }
  .us-event { flex-wrap: wrap; }
  .us-event__aside {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 23px; /* dot + gap, so it lines up with the title */
  }
}

.us-hint {
  font-size: 12px;
  color: var(--color-dim);
  padding: 24px 28px;
  margin: 0;
}

.us-hint--error   { color: var(--color-danger); }
.us-hint--success { color: var(--color-accent); padding: 0; }

.us-input {
  width: 100%;
  padding: 8px 10px;
  background: var(--color-bg-row);
  border: 1px solid var(--color-border);
  border-radius: 5px;
  color: var(--color-text);
  font: inherit;
  font-size: 12px;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.us-input:focus { border-color: var(--color-accent); }

/* Sub-heading inside a section (e.g. Trading Account → Credentials) */
.us-heading {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-text);
  margin: 8px 0 0;
}

/* Inline explanatory text (unlike .us-hint, no padding) */
.us-note {
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-dim);
  margin: 0;
}

.us-note--error { color: var(--color-danger); }

.us-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--color-muted);
  cursor: pointer;
}

/* ─── Toggle switch (checkbox underneath) ────────────────────────────────── */
.us-switch {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  cursor: pointer;
}

.us-switch input {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: inherit;
}

.us-switch__track {
  width: 36px;
  height: 20px;
  border-radius: 10px;
  background: var(--color-bg-row);
  border: 1px solid var(--color-border);
  box-sizing: border-box;
  position: relative;
  transition: background 0.15s, border-color 0.15s;
}

.us-switch__track::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--color-dim);
  transition: transform 0.15s, background 0.15s;
}

.us-switch input:checked + .us-switch__track {
  background: var(--color-accent);
  border-color: var(--color-accent);
}

.us-switch input:checked + .us-switch__track::after {
  transform: translateX(16px);
  background: var(--color-white);
}

.us-switch input:focus-visible + .us-switch__track {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.us-switch input:disabled + .us-switch__track { opacity: 0.5; }
.us-switch:has(input:disabled)                { cursor: not-allowed; }

/* ─── Trading accounts ───────────────────────────────────────────────────── */
.us-autotrading,
.us-emails {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.us-emails { margin-bottom: 24px; }
.us-note--warning { color: #ffcc00; }

/* Paper | Live choice: radio buttons drawn as a segmented control */
.us-segmented {
  display: inline-flex;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  overflow: hidden;
}
.us-segmented__option {
  position: relative;
  cursor: pointer;
}
.us-segmented__option + .us-segmented__option { border-left: 1px solid var(--color-border); }
.us-segmented__option input {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: inherit;
}
.us-segmented__option span {
  display: block;
  padding: 6px 16px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-dim);
  transition: background 0.12s, color 0.12s;
}
.us-segmented__option input:checked + span       { background: rgba(0, 217, 126, 0.15); color: var(--color-accent); }
.us-segmented__option input:focus-visible + span { outline: 2px solid var(--color-accent); outline-offset: -2px; }
.us-segmented__option input:disabled + span      { opacity: 0.4; }
.us-segmented__option:has(input:disabled)        { cursor: not-allowed; }

.us-accounts {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: 8px;
}
.us-account {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 16px;
}
.us-account + .us-account { border-top: 1px solid var(--color-border); }
.us-account__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
.us-account__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.us-account__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}
.us-account__title .badge { padding: 2px 8px; font-size: 10px; }
.us-account__meta {
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-dim);
}
.us-account__meta .us-mono { max-width: none; text-align: left; }
.us-account__actions {
  display: flex;
  gap: 14px;
  flex-shrink: 0;
}
.us-link-btn--danger { color: var(--color-danger); }
.us-account__form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 360px;
}
.us-account__buttons {
  display: flex;
  gap: 8px;
}
.us-account__buttons .us-btn                { width: auto; flex: 1 1; }
.us-account__buttons .us-btn[type="submit"] { flex: 2 1; }

/* Connection check of a login: in progress or its result */
.us-check {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
}
.us-check .us-mono    { max-width: none; }
.us-check--busy       { color: var(--color-blue); }
.us-check--ok         { color: var(--color-accent); }
.us-check--failed     { color: var(--color-danger); }
.us-check--warning    { color: #ffcc00; }
.us-check__spinner {
  width: 10px;
  height: 10px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: us-spin 0.8s linear infinite;
}
@keyframes us-spin { to { transform: rotate(360deg); } }

/* ─── Legacy .settings-page (unused, kept for safety) ────────────────────── */
.settings-page {
  max-width: 560px;
  margin: 40px auto;
  padding: 0 16px 60px;
  font-size: 13px;
  color: var(--color-text);
}

/* ─── Section blocks ─────────────────────────────────────────────────────── */
.settings-section {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 24px 28px;
  margin-bottom: 20px;
  background: var(--color-bg-sub);
}

.settings-section__title {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-dim);
  margin: 0 0 20px;
}

/* ─── Account info rows ──────────────────────────────────────────────────── */
.settings-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--color-border);
}

.settings-row:last-child {
  border-bottom: none;
}

.settings-row__label {
  color: var(--color-dim);
}

.settings-row__value {
  color: var(--color-text);
  font-weight: 500;
}

/* ─── Role / status badges ───────────────────────────────────────────────── */
.badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.badge--admin   { background: rgba(0, 168, 255, 0.15); color: var(--color-blue);   }
.badge--portfolio_manager { background: rgba(0, 217, 126, 0.15); color: var(--color-accent); }
.badge--user    { background: rgba(136, 136, 136, 0.12); color: var(--color-muted); }
.badge--active  { background: rgba(0, 217, 126, 0.15); color: var(--color-accent); }
.badge--inactive { background: rgba(255, 71, 87, 0.12); color: var(--color-danger); }
.badge--mock    { background: rgba(255, 200, 0, 0.12); color: #ffcc00; }
.badge--info    { background: rgba(0, 168, 255, 0.15); color: var(--color-blue);   }
.badge--neutral { background: rgba(136, 136, 136, 0.12); color: var(--color-muted); }
.badge--warning { background: rgba(255, 200, 0, 0.12); color: #ffcc00; }

/* ─── Plan card ──────────────────────────────────────────────────────────── */
.plan-card {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 20px 24px;
  margin: 16px 0 20px;
  background: var(--color-bg-row);
}

.plan-card__name {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-text);
  margin: 0 0 4px;
}

.plan-card__price {
  font-size: 22px;
  font-weight: 700;
  background: var(--gradient-accent);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 16px;
}

.plan-card__price span {
  font-size: 13px;
  font-weight: 400;
  color: var(--color-dim);
  -webkit-text-fill-color: var(--color-dim);
}

.plan-card__features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.plan-card__features li {
  padding: 5px 0;
  color: var(--color-muted);
  display: flex;
  align-items: center;
  gap: 8px;
}

.plan-card__features li::before {
  content: "—";
  color: var(--color-accent);
  flex-shrink: 0;
}

/* ─── Buttons ────────────────────────────────────────────────────────────── */
.settings-btn {
  display: inline-block;
  width: 100%;
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  background: var(--gradient-accent);
  color: var(--color-white);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition: opacity 0.15s;
  text-align: center;
}

.settings-btn:hover { opacity: 0.85; }

.settings-btn--outline {
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-muted);
}

.settings-btn--outline:hover {
  border-color: var(--color-muted);
  color: var(--color-text);
  opacity: 1;
}

.settings-btn--danger {
  background: var(--gradient-danger);
}

/* ─── Mock notice ────────────────────────────────────────────────────────── */
.mock-notice {
  font-size: 11px;
  color: #ffcc00;
  text-align: center;
  margin-top: 10px;
  opacity: 0.7;
}

/* ─── Success confirmation ───────────────────────────────────────────────── */
.settings-success {
  text-align: center;
  padding: 16px 0 4px;
}

.settings-success__icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.settings-success__msg {
  color: var(--color-accent);
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.08em;
}

.settings-success__sub {
  color: var(--color-dim);
  font-size: 11px;
  margin-top: 4px;
}

/* ─── Active subscription details ───────────────────────────────────────── */
.sub-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--color-border);
}

.sub-detail:last-of-type { border-bottom: none; margin-bottom: 20px; }
.sub-detail__label { color: var(--color-dim); }
.sub-detail__value { color: var(--color-text); font-weight: 500; }
`, "",{"version":3,"sources":["webpack://./src/dashboard/pages/UserSettings.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,iBAAiB,EAAE,kEAAkE;EACrF,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,+EAA+E;AAC/E;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,2CAA2C;AAC7C;;AAEA,gBAAgB,wBAAwB,EAAE;;AAE1C;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,+EAA+E;AAC/E;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,+BAA+B,EAAE;;AAE9D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uBAAuB,0BAA0B,EAAE,qCAAqC,EAAE;AAC1F,uBAAuB,wBAAwB,IAAI,mCAAmC,EAAE;;AAExF,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,uBAAuB,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAEzF,+EAA+E;AAC/E;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,SAAS;EACT,+BAA+B,QAAQ,uCAAuC;EAC9E,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;AACA,gCAAgC,SAAS,EAAE;AAC3C,gCAAgC,yBAAyB,EAAE;;AAE3D;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC,EAAE,6BAA6B;AACtE;;AAEA,mCAAmC,+BAA+B,EAAE;AACpE,mCAAmC,6BAA6B,EAAE;AAClE,mCAAmC,+BAA+B,EAAE;;AAEpE;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,kBAAkB;EAClB,6GAA6G;EAC7G,0BAA0B;EAC1B,+CAA+C;AACjD;AACA,6BAA6B,kBAAkB,EAAE;AACjD,sBAAsB,UAAU,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACnE,sBAAsB,UAAU,EAAE,YAAY,EAAE;;AAEhD;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,eAAe,eAAe,EAAE;AAClC;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY,0BAA0B,EAAE;EACxC,YAAY,eAAe,EAAE;EAC7B;IACE,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB,EAAE,6CAA6C;EACnE;AACF;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA,oBAAoB,0BAA0B,EAAE;AAChD,oBAAoB,0BAA0B,EAAE,UAAU,EAAE;;AAE5D;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,kBAAkB,iCAAiC,EAAE;;AAErD,sEAAsE;AACtE;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA,kBAAkB,0BAA0B,EAAE;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,gDAAgD,YAAY,EAAE;AAC9D,gDAAgD,mBAAmB,EAAE;;AAErE,+EAA+E;AAC/E;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,aAAa,mBAAmB,EAAE;AAClC,oBAAoB,cAAc,EAAE;;AAEpC,oEAAoE;AACpE;EACE,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA,gDAAgD,0CAA0C,EAAE;AAC5F;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA,mDAAmD,mCAAmC,EAAE,0BAA0B,EAAE;AACpH,mDAAmD,sCAAsC,EAAE,oBAAoB,EAAE;AACjH,mDAAmD,YAAY,EAAE;AACjE,mDAAmD,mBAAmB,EAAE;;AAExE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA,4BAA4B,yCAAyC,EAAE;AACvE;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,4BAA4B,gBAAgB,EAAE,eAAe,EAAE;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA,6BAA6B,eAAe,EAAE,gBAAgB,EAAE;AAChE;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;AACA,uBAAuB,0BAA0B,EAAE;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA,8CAA8C,WAAW,EAAE,SAAO,EAAE;AACpE,8CAA8C,SAAO,EAAE;;AAEvD,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA,wBAAwB,eAAe,EAAE;AACzC,wBAAwB,wBAAwB,EAAE;AAClD,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,cAAc,EAAE;AACxC;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,+EAA+E;AAC/E;EACE,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,kBAAkB,mCAAmC,EAAE,wBAAwB,IAAI;AACnF,4BAA4B,mCAAmC,EAAE,0BAA0B,EAAE;AAC7F,kBAAkB,qCAAqC,EAAE,yBAAyB,EAAE;AACpF,kBAAkB,mCAAmC,EAAE,0BAA0B,EAAE;AACnF,mBAAmB,mCAAmC,EAAE,0BAA0B,EAAE;AACpF,kBAAkB,mCAAmC,EAAE,cAAc,EAAE;AACvE,kBAAkB,mCAAmC,EAAE,wBAAwB,IAAI;AACnF,kBAAkB,qCAAqC,EAAE,yBAAyB,EAAE;AACpF,kBAAkB,mCAAmC,EAAE,cAAc,EAAE;;AAEvE,+EAA+E;AAC/E;EACE,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,sBAAsB,aAAa,EAAE;;AAErC;EACE,uBAAuB;EACvB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA,+EAA+E;AAC/E;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA,2BAA2B,mBAAmB,EAAE,mBAAmB,EAAE;AACrE,qBAAqB,uBAAuB,EAAE;AAC9C,qBAAqB,wBAAwB,EAAE,gBAAgB,EAAE","sourcesContent":["/* ─── Page layout ────────────────────────────────────────────────────────── */\n.us-page {\n  max-width: 1000px; /* a trading account's title, badges and actions fit on one line */\n  margin: 40px auto;\n  padding: 0 20px 60px;\n  font-size: 13px;\n  color: var(--color-text);\n}\n\n.us-card {\n  display: flex;\n  background: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  overflow: hidden;\n  min-height: 380px;\n}\n\n/* ─── Sidebar ────────────────────────────────────────────────────────────── */\n.us-sidebar {\n  width: 180px;\n  flex-shrink: 0;\n  border-right: 1px solid var(--color-border);\n  background: var(--color-bg-sub);\n  display: flex;\n  flex-direction: column;\n}\n\n.us-sidebar-header {\n  padding: 20px 16px 16px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.us-sidebar-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.us-sidebar-title {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--color-dim);\n  margin: 0;\n}\n\n.us-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n}\n\n.us-nav-btn {\n  width: 100%;\n  text-align: left;\n  padding: 10px 16px;\n  background: none;\n  border: none;\n  border-left: 2px solid transparent;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-dim);\n  cursor: pointer;\n  transition: color 0.12s, border-color 0.12s, background 0.12s;\n}\n\n.us-nav-btn:hover {\n  color: var(--color-text);\n  background: var(--color-bg-row);\n}\n\n.us-nav-btn--active {\n  color: var(--color-accent);\n  border-left-color: var(--color-accent);\n  background: var(--color-bg-row);\n}\n\n/* ─── Body ───────────────────────────────────────────────────────────────── */\n.us-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.us-section {\n  padding: 24px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ─── Fields ─────────────────────────────────────────────────────────────── */\n.us-field {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.us-field:last-of-type {\n  border-bottom: none;\n}\n\n.us-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-dim);\n}\n\n.us-value {\n  font-size: 12px;\n  color: var(--color-text);\n}\n\n.us-mono {\n  font-family: var(--font-mono);\n  font-size: 11px;\n  color: var(--color-muted);\n  word-break: break-all;\n  max-width: 260px;\n  text-align: right;\n}\n\n.us-btn {\n  align-self: flex-start;\n  width: 100%;\n}\n\n/* ─── Billing tabs ───────────────────────────────────────────────────────── */\n.us-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--color-bg-sub);\n}\n\n.us-tab {\n  padding: 10px 20px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: var(--color-dim);\n  cursor: pointer;\n  transition: color 0.12s, border-color 0.12s;\n}\n\n.us-tab:hover { color: var(--color-text); }\n\n.us-tab--active {\n  color: var(--color-accent);\n  border-bottom-color: var(--color-accent);\n}\n\n/* ─── Invoices table ─────────────────────────────────────────────────────── */\n.us-section--flush {\n  padding: 0;\n}\n\n.us-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.us-table th {\n  padding: 8px 16px;\n  text-align: left;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  color: var(--color-dim);\n  background: var(--color-bg-row);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.us-table td {\n  padding: 10px 16px;\n  color: var(--color-text);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.us-table tr:last-child td { border-bottom: none; }\n.us-table tr:hover td      { background: var(--color-bg-row); }\n\n.us-badge {\n  display: inline-block;\n  padding: 2px 7px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.us-badge--paid      { color: var(--color-accent); border: 1px solid var(--color-accent); }\n.us-badge--open      { color: var(--color-blue);   border: 1px solid var(--color-blue); }\n\n/* Text-style action inside table rows (e.g. \"Download PDF\") */\n.us-link-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  font-size: 12px;\n  color: var(--color-accent);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.us-link-btn:hover    { text-decoration: underline; }\n.us-link-btn:disabled { color: var(--color-dim); cursor: default; text-decoration: none; }\n\n/* ─── Billing history (summary + timeline) ───────────────────────────────── */\n.us-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1px;\n  margin: 0;\n  background: var(--color-border);       /* shows through the gaps as dividers */\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.us-stat {\n  padding: 12px 16px;\n  background: var(--color-bg-row);\n}\n\n.us-stat dt {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-dim);\n}\n\n.us-stat dd {\n  margin: 4px 0 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.us-timeline__year {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  color: var(--color-dim);\n  margin: 4px 0 0;\n}\n\n.us-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.us-event {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 12px 0;\n}\n\n/* Vertical line through the dots, from the first dot to the last */\n.us-event::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--color-border);\n}\n.us-event:first-child::before { top: 18px; }\n.us-event:last-child::before  { bottom: calc(100% - 18px); }\n\n.us-event__dot {\n  position: relative;\n  flex-shrink: 0;\n  width: 9px;\n  height: 9px;\n  margin-top: 5px;\n  border-radius: 50%;\n  background: var(--color-dim);\n  box-shadow: 0 0 0 3px var(--color-bg); /* gap between dot and line */\n}\n\n.us-event--start  .us-event__dot { background: var(--color-accent); }\n.us-event--renew  .us-event__dot { background: var(--color-blue); }\n.us-event--cancel .us-event__dot { background: var(--color-danger); }\n\n.us-event__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.us-event__title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.us-event__meta {\n  margin: 3px 0 0;\n  font-size: 12px;\n  color: var(--color-dim);\n}\n\n.us-event__aside {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.us-event__amount {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.us-event__invoice {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Loading placeholders */\n.us-skeleton {\n  display: block;\n  border-radius: 4px;\n  background: linear-gradient(90deg, var(--color-bg-row) 25%, var(--color-border) 50%, var(--color-bg-row) 75%);\n  background-size: 200% 100%;\n  animation: us-shimmer 1.4s ease-in-out infinite;\n}\n.us-event__dot.us-skeleton { border-radius: 50%; }\n.us-skeleton--title { width: 40%; height: 12px; margin: 2px 0 8px; }\n.us-skeleton--meta  { width: 65%; height: 10px; }\n\n@keyframes us-shimmer {\n  from { background-position: 200% 0; }\n  to   { background-position: -200% 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .us-skeleton { animation: none; }\n}\n\n/* Empty and error states */\n.us-empty {\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  padding: 48px 28px;\n}\n\n.us-empty__icon {\n  width: 32px;\n  height: 32px;\n  color: var(--color-dim);\n  margin-bottom: 4px;\n}\n\n.us-empty__title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.us-empty__action {\n  width: auto;\n  margin-top: 8px;\n}\n\n@media (max-width: 560px) {\n  .us-stats { grid-template-columns: 1fr; }\n  .us-event { flex-wrap: wrap; }\n  .us-event__aside {\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    padding-left: 23px; /* dot + gap, so it lines up with the title */\n  }\n}\n\n.us-hint {\n  font-size: 12px;\n  color: var(--color-dim);\n  padding: 24px 28px;\n  margin: 0;\n}\n\n.us-hint--error   { color: var(--color-danger); }\n.us-hint--success { color: var(--color-accent); padding: 0; }\n\n.us-input {\n  width: 100%;\n  padding: 8px 10px;\n  background: var(--color-bg-row);\n  border: 1px solid var(--color-border);\n  border-radius: 5px;\n  color: var(--color-text);\n  font: inherit;\n  font-size: 12px;\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n\n.us-input:focus { border-color: var(--color-accent); }\n\n/* Sub-heading inside a section (e.g. Trading Account → Credentials) */\n.us-heading {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--color-text);\n  margin: 8px 0 0;\n}\n\n/* Inline explanatory text (unlike .us-hint, no padding) */\n.us-note {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--color-dim);\n  margin: 0;\n}\n\n.us-note--error { color: var(--color-danger); }\n\n.us-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--color-muted);\n  cursor: pointer;\n}\n\n/* ─── Toggle switch (checkbox underneath) ────────────────────────────────── */\n.us-switch {\n  position: relative;\n  display: inline-flex;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.us-switch input {\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: inherit;\n}\n\n.us-switch__track {\n  width: 36px;\n  height: 20px;\n  border-radius: 10px;\n  background: var(--color-bg-row);\n  border: 1px solid var(--color-border);\n  box-sizing: border-box;\n  position: relative;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.us-switch__track::after {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--color-dim);\n  transition: transform 0.15s, background 0.15s;\n}\n\n.us-switch input:checked + .us-switch__track {\n  background: var(--color-accent);\n  border-color: var(--color-accent);\n}\n\n.us-switch input:checked + .us-switch__track::after {\n  transform: translateX(16px);\n  background: var(--color-white);\n}\n\n.us-switch input:focus-visible + .us-switch__track {\n  outline: 2px solid var(--color-accent);\n  outline-offset: 2px;\n}\n\n.us-switch input:disabled + .us-switch__track { opacity: 0.5; }\n.us-switch:has(input:disabled)                { cursor: not-allowed; }\n\n/* ─── Trading accounts ───────────────────────────────────────────────────── */\n.us-autotrading,\n.us-emails {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.us-emails { margin-bottom: 24px; }\n.us-note--warning { color: #ffcc00; }\n\n/* Paper | Live choice: radio buttons drawn as a segmented control */\n.us-segmented {\n  display: inline-flex;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  overflow: hidden;\n}\n.us-segmented__option {\n  position: relative;\n  cursor: pointer;\n}\n.us-segmented__option + .us-segmented__option { border-left: 1px solid var(--color-border); }\n.us-segmented__option input {\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: inherit;\n}\n.us-segmented__option span {\n  display: block;\n  padding: 6px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-dim);\n  transition: background 0.12s, color 0.12s;\n}\n.us-segmented__option input:checked + span       { background: rgba(0, 217, 126, 0.15); color: var(--color-accent); }\n.us-segmented__option input:focus-visible + span { outline: 2px solid var(--color-accent); outline-offset: -2px; }\n.us-segmented__option input:disabled + span      { opacity: 0.4; }\n.us-segmented__option:has(input:disabled)        { cursor: not-allowed; }\n\n.us-accounts {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n}\n.us-account {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 14px 16px;\n}\n.us-account + .us-account { border-top: 1px solid var(--color-border); }\n.us-account__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n.us-account__info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n.us-account__title {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text);\n}\n.us-account__title .badge { padding: 2px 8px; font-size: 10px; }\n.us-account__meta {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--color-dim);\n}\n.us-account__meta .us-mono { max-width: none; text-align: left; }\n.us-account__actions {\n  display: flex;\n  gap: 14px;\n  flex-shrink: 0;\n}\n.us-link-btn--danger { color: var(--color-danger); }\n.us-account__form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 360px;\n}\n.us-account__buttons {\n  display: flex;\n  gap: 8px;\n}\n.us-account__buttons .us-btn                { width: auto; flex: 1; }\n.us-account__buttons .us-btn[type=\"submit\"] { flex: 2; }\n\n/* Connection check of a login: in progress or its result */\n.us-check {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.us-check .us-mono    { max-width: none; }\n.us-check--busy       { color: var(--color-blue); }\n.us-check--ok         { color: var(--color-accent); }\n.us-check--failed     { color: var(--color-danger); }\n.us-check--warning    { color: #ffcc00; }\n.us-check__spinner {\n  width: 10px;\n  height: 10px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: us-spin 0.8s linear infinite;\n}\n@keyframes us-spin { to { transform: rotate(360deg); } }\n\n/* ─── Legacy .settings-page (unused, kept for safety) ────────────────────── */\n.settings-page {\n  max-width: 560px;\n  margin: 40px auto;\n  padding: 0 16px 60px;\n  font-size: 13px;\n  color: var(--color-text);\n}\n\n/* ─── Section blocks ─────────────────────────────────────────────────────── */\n.settings-section {\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 24px 28px;\n  margin-bottom: 20px;\n  background: var(--color-bg-sub);\n}\n\n.settings-section__title {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--color-dim);\n  margin: 0 0 20px;\n}\n\n/* ─── Account info rows ──────────────────────────────────────────────────── */\n.settings-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.settings-row:last-child {\n  border-bottom: none;\n}\n\n.settings-row__label {\n  color: var(--color-dim);\n}\n\n.settings-row__value {\n  color: var(--color-text);\n  font-weight: 500;\n}\n\n/* ─── Role / status badges ───────────────────────────────────────────────── */\n.badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.badge--admin   { background: rgba(0, 168, 255, 0.15); color: var(--color-blue);   }\n.badge--portfolio_manager { background: rgba(0, 217, 126, 0.15); color: var(--color-accent); }\n.badge--user    { background: rgba(136, 136, 136, 0.12); color: var(--color-muted); }\n.badge--active  { background: rgba(0, 217, 126, 0.15); color: var(--color-accent); }\n.badge--inactive { background: rgba(255, 71, 87, 0.12); color: var(--color-danger); }\n.badge--mock    { background: rgba(255, 200, 0, 0.12); color: #ffcc00; }\n.badge--info    { background: rgba(0, 168, 255, 0.15); color: var(--color-blue);   }\n.badge--neutral { background: rgba(136, 136, 136, 0.12); color: var(--color-muted); }\n.badge--warning { background: rgba(255, 200, 0, 0.12); color: #ffcc00; }\n\n/* ─── Plan card ──────────────────────────────────────────────────────────── */\n.plan-card {\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 20px 24px;\n  margin: 16px 0 20px;\n  background: var(--color-bg-row);\n}\n\n.plan-card__name {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--color-text);\n  margin: 0 0 4px;\n}\n\n.plan-card__price {\n  font-size: 22px;\n  font-weight: 700;\n  background: var(--gradient-accent);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 0 0 16px;\n}\n\n.plan-card__price span {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--color-dim);\n  -webkit-text-fill-color: var(--color-dim);\n}\n\n.plan-card__features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.plan-card__features li {\n  padding: 5px 0;\n  color: var(--color-muted);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.plan-card__features li::before {\n  content: \"—\";\n  color: var(--color-accent);\n  flex-shrink: 0;\n}\n\n/* ─── Buttons ────────────────────────────────────────────────────────────── */\n.settings-btn {\n  display: inline-block;\n  width: 100%;\n  padding: 12px 24px;\n  border-radius: 6px;\n  border: none;\n  background: var(--gradient-accent);\n  color: var(--color-white);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: opacity 0.15s;\n  text-align: center;\n}\n\n.settings-btn:hover { opacity: 0.85; }\n\n.settings-btn--outline {\n  background: transparent;\n  border: 1px solid var(--color-border);\n  color: var(--color-muted);\n}\n\n.settings-btn--outline:hover {\n  border-color: var(--color-muted);\n  color: var(--color-text);\n  opacity: 1;\n}\n\n.settings-btn--danger {\n  background: var(--gradient-danger);\n}\n\n/* ─── Mock notice ────────────────────────────────────────────────────────── */\n.mock-notice {\n  font-size: 11px;\n  color: #ffcc00;\n  text-align: center;\n  margin-top: 10px;\n  opacity: 0.7;\n}\n\n/* ─── Success confirmation ───────────────────────────────────────────────── */\n.settings-success {\n  text-align: center;\n  padding: 16px 0 4px;\n}\n\n.settings-success__icon {\n  font-size: 28px;\n  margin-bottom: 8px;\n}\n\n.settings-success__msg {\n  color: var(--color-accent);\n  font-weight: 600;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n}\n\n.settings-success__sub {\n  color: var(--color-dim);\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n/* ─── Active subscription details ───────────────────────────────────────── */\n.sub-detail {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.sub-detail:last-of-type { border-bottom: none; margin-bottom: 20px; }\n.sub-detail__label { color: var(--color-dim); }\n.sub-detail__value { color: var(--color-text); font-weight: 500; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
